import { defineNuxtPlugin, useAppConfig, useRequestURL, useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin({
  name: 'host-loader:plugin',
  setup() {
    const config = useRuntimeConfig()
    const appConfig = useAppConfig()
    const url = useRequestURL()

    const hostname = config.public.hostOverride || url.hostname
    appConfig.host = hostname
  },
})
